import {
  FormControlLabel,
  FormControlLabelProps,
  Switch,
  SwitchProps,
  SxProps,
  Theme,
} from "@mui/material";
import Text from "./Text";

type LabeledSwitchProps = {
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  switchProps?: Omit<SwitchProps, "checked" | "onChange">;
  labelFontSize?: string;
  sx?: SxProps<Theme>;
} & Omit<FormControlLabelProps, "control" | "label" | "onChange">;

/**
 * Reusable labeled toggle switch component.
 *
 * @example
 * <LabeledSwitch
 *   label="To-Do Tasks"
 *   checked={isChecked}
 *   onChange={(e) => setIsChecked(e.target.checked)}
 * />
 */
const LabeledSwitch = ({
  label,
  checked,
  onChange,
  switchProps,
  labelFontSize = "12px",
  sx,
  ...others
}: LabeledSwitchProps) => {
  return (
    <FormControlLabel
      sx={{ mr: 0, ...(sx as object) }}
      control={
        <Switch
          size="small"
          checked={checked}
          onChange={onChange}
          {...switchProps}
        />
      }
      label={
        <Text fontSize={labelFontSize} noWrap>
          {label}
        </Text>
      }
      {...others}
    />
  );
};

export default LabeledSwitch;
